module.exports = __webpack_public_path__ + "img/logo_small.43522852.svg";